import { createSelector } from 'reselect';
import { getCompanies } from './entities/userSelectors';

export const initUrlSelector = (state) => state.getIn(['auth', 'initUrl']);

export const authAliasSelector = (state) => state.getIn(['auth', 'alias']);

export const authTokenSelector = (state) => state.getIn(['auth', 'authToken']);

export const authUserIdSelector = (state) => state.getIn(['auth', 'authUser', 'userId']);

export const authUserTypeSelector = (state) => state.getIn(['auth', 'authUser', 'userType']);

export const authUserSelector = (state) => state.getIn(['auth', 'authUser']);

export const authUserCompanyIdSelector = (state) => state.getIn(['auth', 'authUser', 'companyId']);

export const authErrorsSelector = (state) => state.getIn(['auth', 'errors']);

export const emailSelector = (state) => state.getIn(['auth', 'email']);

export const timezoneSelector = (state) => state.getIn(['auth', 'authUser', 'companySettings', 'timezone']);

export const currencySelector = (state) => state.getIn(['auth', 'authUser', 'companySettings', 'currency']);

export const languageSelector = (state) => state.getIn(['auth', 'authUser', 'companySettings', 'language']);

export const authUserCompanySelector = createSelector(
  [authUserCompanyIdSelector, getCompanies],
  (companyId, companies) => {
    return companies.get(companyId);
  },
);
